import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { App } from './App.js';
import { AuthProvider } from './lib/auth.js';
import { ToastProvider } from './components/ui.js';
import './styles/theme.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Shop wifi drops. Serve the last good answer rather than a spinner, and
      // refetch quietly when focus comes back to the tab.
      staleTime: 30_000,
      gcTime: 30 * 60_000,
      retry: 2,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* AuthProvider sits inside the query client: signing out clears the cache. */}
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
